import { render, staticRenderFns } from "./SlideshowItem.vue?vue&type=template&id=29ae6baa&"
import script from "./SlideshowItem.vue?vue&type=script&lang=coffee&"
export * from "./SlideshowItem.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports